import EditAutomationVisuals from './EditAutomationVisualsContainer';

export default EditAutomationVisuals;
